/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Group_LabelInputs */



/**
* | output |
* | --- |
* | "Marker Group" |
*
* @param {Marker_Import_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_group_label = /** @type {((inputs?: Marker_Import_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe de marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Markergruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа маркеров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标记组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Marcadores")
	return /** @type {LocalizedString} */ ("Marker Group")
});